import { useEffect, useRef } from "react";
import { useAuth } from "@/lib/auth";
import { getStoredAccessToken } from "@/lib/api";
import { connectIncidentSocket, disconnectIncidentSocket } from "@/services/incidentService";

export function SocketProvider({ children }) {
  const { user } = useAuth();
  const isConnectedRef = useRef(false);

  useEffect(() => {
    const hasToken = !!getStoredAccessToken();
    const shouldConnect = !!user && hasToken;

    if (shouldConnect && !isConnectedRef.current) {
      connectIncidentSocket();
      isConnectedRef.current = true;
      return;
    }

    if (!shouldConnect && isConnectedRef.current) {
      disconnectIncidentSocket();
      isConnectedRef.current = false;
    }
  }, [user]);

  useEffect(() => {
    return () => {
      if (isConnectedRef.current) {
        disconnectIncidentSocket();
        isConnectedRef.current = false;
      }
    };
  }, []);

  return children;
}
